import { createArchitectureProject, type ArchitectureProject } from '@hyphen-db-studio/architecture-core';
import { create } from 'zustand';
import { pushDiagram } from '../lib/syncDiagram';

/** Client-side cache of the architecture diagrams the signed-in user can see (see useProjectsStore). */
interface ArchitectureProjectsState {
  projects: ArchitectureProject[];
  hydrated: boolean;
  hydrate: () => void;
  setAll: (projects: ArchitectureProject[]) => void;
  createNew: (name: string) => ArchitectureProject;
  remove: (id: string) => void;
  upsert: (project: ArchitectureProject) => void;
  get: (id: string) => ArchitectureProject | undefined;
}

export const useArchitectureProjectsStore = create<ArchitectureProjectsState>((set, get) => ({
  projects: [],
  hydrated: false,

  hydrate: () => {},

  setAll: (projects) => set({ projects, hydrated: true }),

  /** Creates the diagram locally only; the workspace store persists it to the server. */
  createNew: (name) => {
    const project = createArchitectureProject(name);
    set({ projects: [...get().projects, project] });
    return project;
  },

  remove: (id) => set({ projects: get().projects.filter((p) => p.id !== id) }),

  upsert: (project) => {
    set({
      projects: get().projects.some((p) => p.id === project.id)
        ? get().projects.map((p) => (p.id === project.id ? project : p))
        : [...get().projects, project],
    });
    pushDiagram(project.id, project.name, project);
  },

  get: (id) => get().projects.find((p) => p.id === id),
}));
